// extracted by mini-css-extract-plugin
export default {"singleConfig":"EnergyOverviewConfig_singleConfig__9hTD-"};